import "./Groups.scss";
import {
  Card,
  Layout,
  Button,
  notification,
  Skeleton,
  Col,
  Row,
  Empty,
  Space,
  Table,
  Flex,
  Modal,
} from "antd";
import React, { useEffect, useState } from "react";
import type { TableProps } from "antd";
import { DeleteOutlined, FormOutlined, PlusOutlined } from "@ant-design/icons";
import Search from "antd/es/input/Search";
import { useSelector } from "react-redux";
import {
  GroupRaw,
  GroupsMessages,
  PageSetting,
  ProductsMessages,
  Query,
  SortMode,
} from "../../..";
import MenuBar from "../../../components/Menu/MenuBar";
import Footer from "../../../components/Footer/Footer";
import store from "../../../../controllers/store";
import { find } from "../../../../controllers/store/actions/groups/get-groups-actions";
import NewGroupModal from "../../../components/Forms/Modal/Groups/NewGroup";
import UpdateGroupModal from "../../../components/Forms/Modal/Groups/UpdateGroup";
import { findById } from "../../../../controllers/store/actions/groups/update-groups-actions";
import { remove } from "../../../../controllers/store/actions/groups/delete-group-action";
import { clear } from "../../../../controllers/store/actions/groups/create-group-action";

const { confirm } = Modal;
const { Header, Content } = Layout;
const dispatch = store.dispatch;

const query: Query = { filter: {} };
const Groups: React.FC = () => {
  const [visibleCreateModal, setVisibleCreateModal] = useState(false);
  const [visibleUpdateModal, setVisibleUpdateModal] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(PageSetting.limit);
  const [api, contextHolder] = notification.useNotification();
  const groupsState = useSelector((state: any) => state.groups);
  const updatedGroupState = useSelector((state: any) => state.updatedGroup);
  const deletedGroupState = useSelector((state: any) => state.deletedGroup);
  const createdGroupState = useSelector((state: any) => state.createdGroup);
  const userState = useSelector((state: any) => state.user.user);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const columns: TableProps<GroupRaw>["columns"] = [
    {
      title: "Grupo",
      dataIndex: "nme_grupo_gr",
      key: "nme_grupo_gr",
    },
    {
      title: "Código",
      dataIndex: "cod_grupo_gr",
      key: "cod_grupo_gr",
    },
    {
      title: "Clasificación",
      dataIndex: "nme_clasificacion_gr",
      key: "nme_clasificacion_gr",
    },
    {
      title: "Ciudad",
      dataIndex: "city",
      key: "city",
    },

    {
      title: "Área general",
      dataIndex: "nme_area_gr",
      key: "nme_area_gr",
    },

    {
      title: "Área especifica",
      dataIndex: "nme_area_esp_gr",
      key: "nme_area_esp_gr",
    },

    {
      title: "Gran área del conocimiento",
      dataIndex: "nme_gran_area_gr",
      key: "nme_gran_area_gr",
    },

    {
      title: "Fecha de creación",
      dataIndex: "created_at",
      key: "created_at",
    },
    {
      title: "Fecha de modificación",
      dataIndex: "updated_at",
      key: "updated_at",
    },
    {
      title: "Acciones",
      key: "action",
      fixed: "right",
      width: 250,
      render: (_, record: GroupRaw) => (
        <Space size="middle">
          <Button
            type="primary"
            onClick={() => {
              if (record.id) {
                dispatch(findById(record.id));
              }
              setVisibleUpdateModal(!visibleUpdateModal);
            }}
            size="small"
            icon={<FormOutlined />}
          >
            Modificar
          </Button>
          <Button
            type="default"
            onClick={() => {
              confirm({
                okType: "primary",
                okText: "Borrar",
                cancelText: "Cancelar",
                title: GroupsMessages.Title,
                content: GroupsMessages.GroupsConfirmDeleteMessage,
                onOk: async () => {
                  if (record.id) {
                    await dispatch(remove(record.id));
                    dispatch(find(page, pageSize, query));
                  }
                },
                onCancel() {},
              });
            }}
            size="small"
            icon={<DeleteOutlined />}
          >
            Eliminar
          </Button>
        </Space>
      ),
    },
  ];

  const showCreatedGroupMessageSuccess = () => {
    api["success"]({
      key: 1,
      message: GroupsMessages.Title,
      description: GroupsMessages.GroupCreated,
    });
    dispatch(clear());
    return null;
  };

  const showDeletedGroupMessage = () => {
    api["success"]({
      key: 1,
      message: GroupsMessages.Title,
      description: GroupsMessages.GroupsDeleteSuccessMessage,
    });

    dispatch(clear());
    return null;
  };

  const showUpdatedGroupMessage = () => {
    api["success"]({
      key: 1,
      message: GroupsMessages.Title,
      description: GroupsMessages.GroupsUpdateSuccessMessage,
    });

    dispatch(clear());
    return null;
  };

  useEffect(() => {
    dispatch(find(1, pageSize, { filter: {} }));
    setInitialDataLoaded(true);
  }, [pageSize]);

  const handleSearch = (value: string) => {
    setSearchTerm(value);
    if (value) {
      query.search = value;
      query.meta = "filter_count";
    } else {
      delete query.search;
    }
    dispatch(find(1, pageSize, query));
  };

  return (
    <Layout className="products-layout">
      {contextHolder}
      {createdGroupState.createdGroup ? showCreatedGroupMessageSuccess() : null}
      {deletedGroupState.removed ? showDeletedGroupMessage() : null}
      {updatedGroupState.updatedGroup ? showUpdatedGroupMessage() : null}
      <MenuBar />
      <Header className="bg-header-profile" />
      <Content className="product-content">
        <Card className="products-card">
          <Col xs={24} sm={12} md={8} lg={12}>
            <h1 className="heading-content-title">
              Entidades
              <span className="heading-content-subtitle">
                Grupos de investigación
              </span>
            </h1>
          </Col>
          <br />
          <NewGroupModal
            visible={visibleCreateModal}
            onCreated={() => {
              setVisibleCreateModal(false);
              dispatch(find(page, pageSize, query));
            }}
            onCancel={() => {
              setVisibleCreateModal(false);
            }}
          />
          <UpdateGroupModal
            group={updatedGroupState.group}
            visible={visibleUpdateModal}
            onUpdated={() => {
              setVisibleUpdateModal(false);
              dispatch(find(page, pageSize, query));
            }}
            onCancel={() => {
              setVisibleUpdateModal(false);
            }}
          />
          {!initialDataLoaded && groupsState?.list?.length === 0 ? (
            <>
              <br />
              <br />
              <br />
              <br />
              <Empty
                image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                imageStyle={{ height: 60 }}
                description={<span>No tienes grupos aún</span>}
              >
                <Button
                  icon={<PlusOutlined />}
                  onClick={() => {
                    setVisibleCreateModal(!visibleCreateModal);
                  }}
                  type="primary"
                >
                  Agregar grupo
                </Button>
              </Empty>
              <br />
              <br />
              <br />
              <br />
            </>
          ) : (
            <>
              <Row gutter={[8, 8]} style={{ width: "100%", marginBottom: 20 }}>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <Flex vertical={true} align={"flex-start"}>
                    <Search
                      placeholder="Buscar"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onSearch={handleSearch}
                      enterButton
                    />
                  </Flex>
                </Col>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <Flex vertical={true} align={"flex-end"}>
                    <Button
                      type="primary"
                      onClick={() => setVisibleCreateModal(!visibleCreateModal)}
                      size="middle"
                      icon={<PlusOutlined />}
                    >
                      Agregar grupo
                    </Button>
                  </Flex>
                </Col>
              </Row>
              <Skeleton
                loading={groupsState.isLoading}
                active
                className="full-width"
              >
                <Table
                  scroll={{ x: 1500 }}
                  sticky={{ offsetHeader: 0 }}
                  pagination={{
                    locale: {
                      jump_to: "Ir a",
                      items_per_page: "Items por pagina",
                    },
                    total:
                      groupsState.meta?.total_count ||
                      groupsState.meta?.filter_count,
                    current: page,
                    pageSize: PageSetting.limit,
                    onChange: (page) => {
                      dispatch(find(page, pageSize, query));
                      setPage(page);
                    },
                    onShowSizeChange: (pageSize) => {
                      dispatch(find(page, pageSize, query));
                      setPageSize(pageSize);
                    },
                  }}
                  locale={{ emptyText: "Sin Resultados." }}
                  columns={columns}
                  dataSource={groupsState.list}
                />
              </Skeleton>
            </>
          )}
        </Card>
      </Content>
      <Footer />
    </Layout>
  );
};

export default Groups;
